import React from 'react';

function BackIcon({ stroke = '#6267AC' }: { stroke?: string }) {
  return (
    <svg
      width='22'
      height='18'
      viewBox='0 0 22 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M21 9H1M1 9L8.5 16.5M1 9L8.5 1.5'
        stroke={stroke}
        strokeWidth='2'
        strokeLinejoin='round'
        strokeLinecap='round'
      />
    </svg>
  );
}

export default BackIcon;
